<mat-toolbar color="accent" class="navbar navbar-expand-lg bg-body-tertiary position-absolute"
             *ngIf="(isLoggedIn || readModeAppState) && !hideToolbar">
  <div class="w-100 d-flex justify-content-between align-items-center toolbar-scroll">
    <div class="d-flex align-items-center justify-content-center">
      <!-- If inside an IFRAME, link out to Maporium website -->
      <!-- Logotype click opens About dialog -->
      @if (isInIframe()) {
        <a class="navbar-brand ps-1 me-0"
           tourAnchor="logo-anchor"
           [matTooltip]="'NAV_MISC.ABOUT_SMAP' | translate"
           href="#"
           (click)="$event.preventDefault(); openAboutDialog()">
          <span class="logo-icon icon-smap-logotype-smap-powered"></span>
        </a>
      } @else {
        <a class="navbar-brand ps-1 me-0"
           tourAnchor="logo-anchor"
           [matTooltip]="'NAV_MISC.ABOUT_SMAP' | translate"
           href="#"
           (click)="$event.preventDefault(); openAboutDialog()">
          <span class="logo-icon icon-smap-logotype-smap-large"></span>
        </a>
      }
    </div>

    <!-- Smap Group: Store + Smaps (store-smaps-group) then Assistant -->
    <!-- MAP-1245 bubble 11 anchor wraps only store+smaps; assistant is separate. -->
    @if (!readModeAppState && !isIframe && !isDefaulter) {
      <div class="d-flex align-items-center justify-content-center smap-group">
        <div class="d-flex align-items-center justify-content-center store-smaps-group" tourAnchor="store-smaps-group">
          <button mat-icon-button
                  [attr.aria-label]="'NAV_MISC.STORE_ARIA' | translate"
                  tourAnchor="store-anchor"
                  [matTooltip]="'NAV_MISC.STORE_TOOLTIP' | translate"
                  (click)="openStoreBottomsheet()">
            <span class="icon-smap-function-store"></span>
          </button>
          <button mat-icon-button [attr.aria-label]="'NAV_MISC.MANAGE_SMAPS_ARIA' | translate"
                  [matTooltip]="'TOOLTIP.CREATE_MANAGE_OPEN_SMAPS' | translate"
                  tourAnchor="smaps-menu-anchor"
                  (click)="reloadMapList()"
                  [matMenuTriggerFor]="mapMenu">
            @if (isSmapGenerating) {
              <span class="smap-toolbar-lottie"></span>
            } @else {
              <span class="icon-smap-object-smap"></span>
            }
          </button>
        </div>
        <!-- MAP-147: AI off reclaims the space rather than greying the button. -->
        @if (aiStateService.isAiVisible()) {
          <div class="ai-button-container">
            <button mat-icon-button
                    *appHasPackage="[packagenames.creator, packagenames.analyst, packagenames.publisher, packagenames.developer]"
                    [attr.aria-label]="'NAV_MISC.ASSISTANT_ARIA' | translate"
                    tourAnchor="assistant-anchor"
                    [disabled]="!canUseAssistant()"
                    [matTooltip]="('TOOLTIP.SMART_ASSISTANT' | translate)"
                    (click)="openGptDialog($event)">
              @if (isAssistantAnimating) {
                <span class="assistant-toolbar-lottie"></span>
              } @else {
                <span class="icon-smap-function-assistant"></span>
              }
            </button>
            <div *ngIf="showAiBubble && aiBubbleSources.toolbar" class="ai-bubble-toolbar-container">
              <app-ai-generation-bubble
                [config]="aiBubbleConfig"
                (openSettings)="openSettings()"
                (close)="onAiBubbleClose()"
                class="toolbar-positioned">
              </app-ai-generation-bubble>
            </div>
          </div>
        }
      </div>
    }

    @if (isIframe) {
      <span class="mx-2" style="font-weight: 400;">{{ currentMap?.name }}</span>
    }

    <!-- Map Group not in IFRAME-->
    @if (!readModeAppState) {
      <div class="d-flex align-items-center justify-content-center smap-title-group" tourAnchor="smap-title-group">
        <button mat-icon-button
                [matTooltip]="'TOOLTIP.MAP_ACTIONS' | translate"
                [matMenuTriggerFor]="mapActionsMenu"
                *ngIf="currentMap">
          <span [ngClass]="[getMapAccessIcon()]"></span>
        </button>

        @if (currentMap && currentMap.owner) {
          @if ((currentMap!.owner.id === currentUser?.id || canEdit()) && !isDefaulter) {
            <form id="mapNameForm">
              <app-text-input id="mapNameInput"
                              #mapNameInputValue
                              tabindex="0"
                              (keydown)="onMapNameKeydown($event, mapNameInputValue)"
                              (hasBlured)="stopMapEdit($event)"
                              [value]="topToolbarStateService.mapName$()"
                              [disableFormControl]="true"
                              [autoSelect]="false"
                              [autoAdjust]="true"
                              [minWidth]="100"
                              [maxWidth]="500"
                              [noTopMargin]="true"></app-text-input>
            </form>
          } @else {
            <span class="mx-2" style="font-weight: 400;">{{ currentMap.name || '' }}</span>
          }
        }

        @if (isIframe && mapStates.length > 0 || !isIframe) {
          @if (currentMap && shouldShowStatesMenu()) {
            <button mat-icon-button
                    [matMenuTriggerFor]="mapStateMenu"
                    [matTooltip]="isInIframe() ? 'Show states' : ('TOOLTIP.CREATE_MANAGE_SHOW_STATES' | translate)"
                    (click)="openStateMenu()">
              <div class="custom-icon-wrapper">
                          <span [ngClass]="currentNotDefaultMapStateId === null
                                            ? 'icon-smap-object-state'
                                            : 'icon-smap-object-state-custom'">
                          </span>
              </div>
            </button>
          }
          <span style="font-weight: 400; font-size: 14px"
                *ngIf="currentNotDefaultMapState as state">{{ state }}</span>
        }

      </div>
    }

    <!-- State menu for iframe-->
    @if (isIframe && mapStates.length > 0) {
      <div class="state-wrapper-smaplet d-flex align-items-center">
        <button mat-icon-button
                [matMenuTriggerFor]="mapStateMenu"
                [matTooltip]="'TOOLBAR.SHOW_STATES' | translate"
                (click)="openStateMenu()"
                *ngIf="currentMap">
          <div class="custom-icon-wrapper">
                <span [ngClass]="currentNotDefaultMapStateId === null
                                  ? 'icon-smap-object-state'
                                  : 'icon-smap-object-state-custom'">
                </span>
          </div>
        </button>
        <span style="font-weight: 400; font-size: 14px"
              *ngIf="currentNotDefaultMapState as state">{{ state }}</span>
      </div>
    }

    <!-- Tool Group-->
    <div class="d-flex align-items-center justify-content-center home-scenes-stories-group" tourAnchor="home-scenes-stories-group">
      <button (click)="centerCanvas()"
              *ngIf="currentMap"
              [attr.aria-label]="'NAV_MISC.CENTER_CANVAS_ARIA' | translate"
              mat-icon-button
              [matTooltip]="'TOOLTIP.CENTER_CANVAS' | translate">
        <span class="icon-smap-concept-home"></span>
      </button>
      <div class="scene-tour-group" tourAnchor="scenes-stories-menu-anchor">
        @if (currentMap && shouldShowScenesMenu()) {
          <button mat-icon-button
                  [attr.aria-label]="'NAV_MISC.SAVED_SCENES_ARIA' | translate"
                  [matTooltip]="isInIframe() ? ('NAV_MISC.VIEW_SCENES' | translate) : ('TOOLTIP.CREATE_MANAGE_VIEWS' | translate)"
                  (click)="loadToursAndViews()"
                  tourAnchor="views-menu-anchor"
                  [matMenuTriggerFor]="viewsMenu">
            <span class="icon-smap-object-scene"></span>
          </button>
        }

        @if (currentMap && shouldShowStoriesMenu()) {
          <button mat-icon-button
                  [attr.aria-label]="'TOOLBAR.STORIES' | translate"
                  tourAnchor="tours-menu-anchor"
                  [matTooltip]="isInIframe() ? ('NAV_MISC.PLAY_STORIES' | translate) : ('TOOLTIP.CREATE_MANAGE_STORIES' | translate)"
                  (click)="loadToursAndViews()"
                  [matMenuTriggerFor]="tourMenu">
            <span class="icon-smap-object-story"></span>
          </button>
        }
      </div>
    </div>

    <!-- Find Group-->
    <div class="d-flex align-items-center justify-content-center">
      <button [matMenuTriggerFor]="linkViewModeMenu"
              [attr.aria-label]="'NAV_MISC.TOGGLE_LINK_VISIBILITY_ARIA' | translate"
              tourAnchor="link-menu-anchor"
              class="d-flex align-items-center justify-content-center"
              [matTooltip]="'TOOLTIP.TOGGLE_LINK_VISIBILITY' | translate"
              mat-icon-button>
        <ng-container [ngSwitch]="currentEdgeView">
          <span *ngSwitchCase="0" class="s-icon icon-smap-linkage-all"></span>
          <span *ngSwitchCase="1" class="s-icon icon-smap-linkage-none"></span>
          <span *ngSwitchCase="2" class="s-icon icon-smap-linkage-attached"></span>
          <span *ngSwitchCase="3" class="s-icon icon-smap-linkage-enclosed"></span>
        </ng-container>

      </button>

      @if (currentMap) {
        <button [matMenuTriggerFor]="filterMenu"
                (click)="loadFiltersForMenu()"
                [attr.aria-label]="'TOOLBAR.MANAGE_FILTERS_TOOLTIP' | translate"
                class="d-flex align-items-center justify-content-center"
                [matTooltip]="isInIframe() ? ('NAV_MISC.TOGGLE_FILTERS' | translate) : ('TOOLBAR.MANAGE_FILTERS_TOOLTIP' | translate)"
                mat-icon-button *appHasPackage="[packagenames.developer, packagenames.defaulter]">
          <span class="icon-smap-object-filter"></span>
        </button>
      }
    </div>
    @if (!readModeAppState) {
      <!-- Edit Group-->
      <div class="d-flex align-items-center justify-content-center">
      @if (currentMap && !isIframe && shouldShowModelsMenu()) {
          <button [matMenuTriggerFor]="modelsMenu"
                  (click)="loadModelsForMenu()"
                  *appHasPackage="[packagenames.creator, packagenames.analyst, packagenames.publisher, packagenames.developer, packagenames.defaulter]"
                  [disabled]="!canEdit() && !canManage() || isDefaulter"
                  [attr.aria-label]="'TOOLBAR.MANAGE_MODELS_TOOLTIP' | translate"
                  class="d-flex align-items-center justify-content-center"
                  tourAnchor="models-menu-anchor"
                  [matTooltip]="'TOOLBAR.MANAGE_MODELS_TOOLTIP' | translate"
                  mat-icon-button>
            <span class="icon-smap-object-model"></span>
          </button>
        }
        @if (currentMap) {
          @if (isRectangleFeatureEnabled) {
            <button mat-icon-button
                    [attr.aria-label]="'DASHBOARD_MSG.MENU.ADD_RECTANGLE' | translate"
                    [disabled]="!canEdit()"
                    [matTooltip]="'DASHBOARD_MSG.MENU.ADD_RECTANGLE' | translate"
                    (click)="addRectangle()">
              <mat-icon class="material-symbols-rounded">rectangle</mat-icon>
            </button>
          }
        }
        <button mat-icon-button
                *ngIf="showGptSave"
                [attr.aria-label]="'NAV_MISC.CANCEL_GPT_ARIA' | translate"
                [disabled]="currentMap?.isReadonly === true"
                [matTooltip]="'TOOLTIP.CANCEL_GPT_GENERATOR' | translate"
                (click)="cancelGptGeneratedMap()">
          <mat-icon>cancel</mat-icon>
        </button>
        <button mat-icon-button
                *ngIf="showGptSave"
                [attr.aria-label]="'TOOLTIP.ADD_TO_MAP' | translate"
                [disabled]="currentMap?.isReadonly === true"
                [matTooltip]="'TOOLTIP.ADD_TO_MAP' | translate"
                (click)="handleGpt('map')">
          <mat-icon>done</mat-icon>
        </button>
      </div>
    }
    <div class="d-flex align-items-center gap-5" tourAnchor="help-user-mode-group">
    <div class="d-flex align-items-center justify-content-center help-user-group">
      <button [matMenuTriggerFor]="helpMenu"
              [matTooltip]="'TOOLTIP.HELP' | translate"
              [attr.aria-label]="'HELP_MENU.TOOLTIP' | translate"
              mat-icon-button>
        <span class="icon-smap-concept-help"></span>
      </button>

      @if (!isIframe) {
        <app-user-menu>
          <mat-menu class="toolbar-menu">
            <button mat-menu-item
                    [attr.aria-label]="'TOOLBAR.ACCOUNT' | translate"
                    [matTooltip]="'TOOLTIP.ACCOUNT_SETTINGS' | translate"
                    matTooltipPosition="left"
                    (click)="openAccount()">
              <mat-icon class="material-symbols-rounded">account_circle</mat-icon>
              <span>{{ 'MENU.ACCOUNT' | translate }}</span>
            </button>
            <button mat-menu-item
                    [attr.aria-label]="'NAV_MISC.AI_USAGE_ARIA' | translate"
                    [matTooltip]="'TOOLTIP.AI_USAGE' | translate"
                    matTooltipPosition="left"
                    (click)="openAiUsage()">
              <span class="icon-smap-credit-usage"></span>
              <span>{{ 'MENU.AI_USAGE' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item
                    [attr.aria-label]="'NAV_MISC.PROFILE_ARIA' | translate"
                    [matTooltip]="'TOOLTIP.PROFILE_SETTINGS' | translate"
                    matTooltipPosition="left"
                    (click)="openProfile()">
              <mat-icon class="material-symbols-rounded">badge</mat-icon>
              <span>{{ 'MENU.PROFILE' | translate }}</span>
            </button>
            <button mat-menu-item
                    [attr.aria-label]="'TOOLBAR.SETTINGS' | translate"
                    [matTooltip]="'TOOLTIP.CONFIGURE_SETTINGS' | translate"
                    matTooltipPosition="left"
                    (click)="openSettings()">
              <span class="icon-smap-user-settings"></span>
              <span>{{ 'MENU.SETTINGS' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item
                    (click)="logout()">
              <mat-icon class="material-symbols-rounded">logout</mat-icon>
              <span>{{ 'MENU.LOGOUT' | translate }}</span>
            </button>
          </mat-menu>
        </app-user-menu>
      }
    </div>

    <div class="d-flex align-items-center justify-content-center mode-sidebar-group">
      <ng-container *hasMapPermission="'edit'">
        @if (!isDefaulter) {
          <maporium-edit-mode-button *ngIf="currentMap"
                                     [readonly]="currentMap.isReadonly && !canEdit()">
          </maporium-edit-mode-button>
        }
      </ng-container>
      <button (click)="toggleSidebar()"
              [matTooltip]="isSidebarOpen ? ('TOOLTIP.HIDE_SIDEBAR' | translate)
                                             : ('TOOLTIP.SHOW_SIDEBAR' | translate)"
              mat-icon-button>
        <span *ngIf="!isSidebarOpen; else sidebarOpenedIcon" class="icon-smap-sidebar-show"></span>
        <ng-template #sidebarOpenedIcon>
          <span class="icon-smap-sidebar-hide"></span>
        </ng-template>
      </button>
    </div>
    </div>
  </div>

  <mat-progress-bar *ngIf="isBlocking && !isPropertyGenerating && !isMapLoading" color="primary" mode="indeterminate"></mat-progress-bar>

</mat-toolbar>

<mat-menu #mapActionsMenu="matMenu" class="toolbar-menu">
  @if (currentMap) {
    @if (!isDefaulter) {
      <button mat-menu-item
              [disabled]="!canManage()" (click)="editMap()">
        <mat-icon class="material-symbols-rounded">edit</mat-icon>
        <span>{{ 'MENU.UPDATE' | translate }}</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item
              [disabled]="currentMap?.isReadonly === true && !canManage()"
              (click)="duplicateMap()">
        <mat-icon class="material-symbols-rounded">file_copy</mat-icon>
        <span>{{ 'MENU.DUPLICATE' | translate }}</span>
      </button>
    }
    <button mat-menu-item
            [disabled]="currentMap?.isReadonly === true && !canManage()"
            [matMenuTriggerFor]="exportSubmenu"
            *appHasPackage="[packagenames.creator, packagenames.developer, packagenames.analyst, packagenames.publisher, packagenames.defaulter]">
      <mat-icon class="material-symbols-rounded">download</mat-icon>
      <span>{{ 'MENU.EXPORT' | translate }}</span>
    </button>
    <button mat-menu-item
            [disabled]="currentMap?.isReadonly === true && !isOwner"
            (click)="transferMap()">
      <mat-icon class="material-symbols-rounded">passkey</mat-icon>
      <span>{{ 'MENU.TRANSFER' | translate }}</span>
    </button>
    @if (!isDefaulter) {
      <mat-divider></mat-divider>
      <button mat-menu-item [disabled]="!canManage()"
              (click)="shareMap()">
        <mat-icon class="material-symbols-rounded">person_add</mat-icon>
        <span>{{ 'MENU.SHARE' | translate }}</span>
      </button>
    }
    <button mat-menu-item
            *appHasPackage="[packagenames.analyst, packagenames.publisher, packagenames.developer]"
            [disabled]="!canManage()"
            (click)="openPublishDialog()">
      <mat-icon class="material-symbols-rounded">campaign</mat-icon>
      <span>Publish…</span>
    </button>
    <button mat-menu-item
            *appHasPackage="[packagenames.developer, packagenames.creator, packagenames.analyst, packagenames.publisher]"
            [disabled]="!canManage()"
            (click)="embedMap()">
      <mat-icon class="material-symbols-rounded">integration_instructions</mat-icon>
      <span>{{ 'MENU.EMBED' | translate }}</span>
    </button>
    @if (aiStateService.isAiVisible()) {
      <button mat-menu-item
              *appHasPackage="[packagenames.analyst, packagenames.developer]"
              (click)="openAiOptimizerDialog()">
        <mat-icon class="material-symbols-rounded">troubleshoot</mat-icon>
        <span>AI Optimizer…</span>
      </button>
    }
    <mat-divider></mat-divider>
    <button mat-menu-item *ngIf="!currentMap?.isReadonly; else readOnlyRemove"
            (click)="deleteMapConfirm()">
      <mat-icon class="material-symbols-rounded">delete</mat-icon>
      <span>{{ 'MENU.DELETE' | translate }}</span>
    </button>
    <ng-template #readOnlyRemove>
      <button mat-menu-item (click)="removeMapFromSharedWithMe()">
        @if (currentMap && isInLibrary(currentMap) && !isSharedWithMe(currentMap)) {
          <mat-icon class="material-symbols-rounded">remove</mat-icon>
          <span>Remove from Collection…</span>
        } @else {
          <mat-icon class="material-symbols-rounded">person_remove</mat-icon>
          <span>{{ 'MENU.REMOVE' | translate }}</span>
        }
      </button>
    </ng-template>
  }
</mat-menu>
<!-- Export Submenu -->
<mat-menu #exportSubmenu="matMenu" class="toolbar-menu">
  @if (currentMap) {
    <button mat-menu-item
            *appHasPackage="[packagenames.creator, packagenames.analyst, packagenames.publisher, packagenames.developer, packagenames.defaulter]"
            [disabled]="currentMap?.isReadonly === true && !canManage()"
            (click)="exportMap()">
      <i class="icon-smap-format-smap"></i>
      <span>to SMAP Archive (.smap)…</span>
    </button>

    <mat-divider></mat-divider>

    <button mat-menu-item
            [disabled]="currentMap?.isReadonly === true && !canManage()"
            (click)="exportAsPng()">
      <i class="icon-smap-format-png"></i>
      <span>to PNG Image (.png)…</span>
    </button>
  }
</mat-menu>

<mat-menu #mapStateMenu="matMenu" class="toolbar-menu">
  @if (currentMap) {
    @if (!isInIframe()) {
      <button mat-menu-item
              *appHasPackage="[packagenames.analyst, packagenames.publisher, packagenames.developer]"
              (click)="createMapState()"
              [disabled]="!canEdit()">
        <i class="icon-smap-action-create"></i>
        <span>{{ 'MENU.CREATE_STATE' | translate }}</span>
      </button>
      @if (hasExperimentalStateCreate && currentNotDefaultMapStateId) {
        <button mat-menu-item
                *appHasPackage="[packagenames.analyst, packagenames.publisher, packagenames.developer]"
                (click)="createMapStateFromCurrent()"
                [disabled]="!canEdit()">
          <i class="icon-smap-action-create"></i>
          <span>{{ 'NAV_MISC.CREATE_STATE_FROM_CURRENT' | translate }}</span>
        </button>
      }
      <button mat-menu-item
              (click)="openStateListSheet()"
              *appHasPackage="[packagenames.analyst, packagenames.publisher, packagenames.developer]"
              [disabled]="!canEdit()">
        <span class="icon-smap-action-manage"></span>
        <span>{{ 'MENU.MANAGE_STATES' | translate }}</span>
      </button>
      @if (mapStates.length > 0 && (canEdit() || isOwner)) {
        @if (!isDefaulter) {
          <mat-divider></mat-divider>
        }
        <button mat-menu-item
                (click)="selectMapState(defaultState)">
          <mat-icon *ngIf="currentNotDefaultMapStateId === null; else notSelected"
                    class="material-symbols-outlined">
            check
          </mat-icon>
          {{ 'MENU.STATE_BASE' | translate }}
        </button>
        <mat-divider></mat-divider>
      } @else if (mapStates.length > 0 && !isDefaulter) {
        <!-- Separator for viewers/commenters (no Base state, but need separator after Manage States) -->
        <mat-divider></mat-divider>
      }
    }
    @for (mapState of mapStates; track mapState.id) {
      <button mat-menu-item
              class="d-flex align-items-center"
              matTooltipPosition="right"
              [matTooltip]="mapState.description || mapState.name"
              (click)="selectMapState(mapState)">
        <mat-icon *ngIf="mapState.id === currentNotDefaultMapStateId; else notSelected"
                  class="material-symbols-outlined">
          check
        </mat-icon>

        <span>{{ mapState.name }}</span>
      </button>
    }

    <ng-template #notSelected>
      <mat-icon class="empty-icon"></mat-icon>
    </ng-template>
  }
</mat-menu>

<mat-menu #linkViewModeMenu="matMenu" class="toolbar-menu">
  <button (click)="toggleEdges(0)" mat-menu-item>
    <mat-icon *ngIf="currentEdgeView === 0">check</mat-icon>
    <mat-icon *ngIf="currentEdgeView !== 0"></mat-icon>
    <span>{{ 'LINKS.ALL' | translate }}</span>
  </button>
  <button (click)="toggleEdges(2)" mat-menu-item>
    <mat-icon *ngIf="currentEdgeView !== 2"></mat-icon>
    <mat-icon *ngIf="currentEdgeView === 2">check</mat-icon>
    <span>{{ 'LINKS.SELECTION_CONNECTED' | translate }}</span>
  </button>
  <button (click)="toggleEdges(3)" mat-menu-item>
    <mat-icon *ngIf="currentEdgeView !== 3"></mat-icon>
    <mat-icon *ngIf="currentEdgeView === 3">check</mat-icon>
    <span>{{ 'LINKS.SELECTION_ENCLOSED' | translate }}</span>
  </button>
  <button (click)="toggleEdges(1)" mat-menu-item>
    <mat-icon *ngIf="currentEdgeView !== 1"></mat-icon>
    <mat-icon *ngIf="currentEdgeView === 1">check</mat-icon>
    <span>{{ 'LINKS.NONE' | translate }}</span>
  </button>
  <mat-divider></mat-divider>
  <button (click)="setOtherLinksMode(otherLinksModes.DIMMED)" mat-menu-item>
    <mat-icon *ngIf="otherLinksMode !== otherLinksModes.DIMMED"></mat-icon>
    <mat-icon *ngIf="otherLinksMode === otherLinksModes.DIMMED">check</mat-icon>
    <span>{{ 'LINKS.OTHER_DIMMED' | translate }}</span>
  </button>
  <button (click)="setOtherLinksMode(otherLinksModes.DIMMED_UNLABELED)" mat-menu-item>
    <mat-icon *ngIf="otherLinksMode !== otherLinksModes.DIMMED_UNLABELED"></mat-icon>
    <mat-icon *ngIf="otherLinksMode === otherLinksModes.DIMMED_UNLABELED">check</mat-icon>
    <span>{{ 'LINKS.OTHER_DIMMED_UNLABELED' | translate }}</span>
  </button>
  <button (click)="setOtherLinksMode(otherLinksModes.HIDDEN)" mat-menu-item>
    <mat-icon *ngIf="otherLinksMode !== otherLinksModes.HIDDEN"></mat-icon>
    <mat-icon *ngIf="otherLinksMode === otherLinksModes.HIDDEN">check</mat-icon>
    <span>{{ 'LINKS.OTHER_HIDDEN' | translate }}</span>
  </button>
  <mat-divider></mat-divider>
  <button (click)="setOtherNodesMode(otherNodesModes.SHOWN)" mat-menu-item>
    <mat-icon *ngIf="otherNodesMode !== otherNodesModes.SHOWN"></mat-icon>
    <mat-icon *ngIf="otherNodesMode === otherNodesModes.SHOWN">check</mat-icon>
    <span>{{ 'NODES_DISPLAY.OTHER_SHOWN' | translate }}</span>
  </button>
  <button (click)="setOtherNodesMode(otherNodesModes.DIMMED)" mat-menu-item>
    <mat-icon *ngIf="otherNodesMode !== otherNodesModes.DIMMED"></mat-icon>
    <mat-icon *ngIf="otherNodesMode === otherNodesModes.DIMMED">check</mat-icon>
    <span>{{ 'NODES_DISPLAY.OTHER_DIMMED' | translate }}</span>
  </button>
  <button (click)="setOtherNodesMode(otherNodesModes.DIMMED_UNLABELED)" mat-menu-item>
    <mat-icon *ngIf="otherNodesMode !== otherNodesModes.DIMMED_UNLABELED"></mat-icon>
    <mat-icon *ngIf="otherNodesMode === otherNodesModes.DIMMED_UNLABELED">check</mat-icon>
    <span>{{ 'NODES_DISPLAY.OTHER_DIMMED_UNLABELED' | translate }}</span>
  </button>
</mat-menu>
<mat-menu #filterMenu="matMenu" class="toolbar-menu">
  @if (currentMap) {
    @if (!isDefaulter) {
      <button mat-menu-item
              *ngIf="canManageFilters"
              (click)="createFilter()"
              [disabled]="!canEdit()">
        <i class="icon-smap-action-create"></i>
        <span>{{ 'NAV_MISC.CREATE_FILTER' | translate }}</span>
      </button>
      <button mat-menu-item
              *ngIf="canManageFilters"
              (click)="selectFilter()"
              [disabled]="!canEdit()">
        <span class="icon-smap-action-manage"></span>
        <span>{{ 'NAV_MISC.MANAGE_FILTERS' | translate }}</span>
      </button>
      <mat-divider *ngIf="filters.length && canManageFilters"></mat-divider>
    }

    <ng-container *ngIf="!canManageFilters && filters.length === 0">
      <button disabled mat-menu-item>{{ 'NAV_MISC.NO_FILTERS_AVAILABLE' | translate }}</button>
    </ng-container>
    <ng-container *ngIf="filters.length > 0">
      @for (filter of filters; track filter.id) {
        <button mat-menu-item
                (click)="selectFilter(filter)"
                matTooltipPosition="right"
                [matTooltip]="filter.description ? filter.description : filter.name">
          <mat-icon *ngIf="isFilterActive(filter.id)"
                    class="material-symbols-outlined">check
          </mat-icon>
          <mat-icon *ngIf="!isFilterActive(filter.id)"
                    class="empty-icon"></mat-icon>
          <span>{{ filter.name }}</span>
          <mat-icon *ngIf="filter.isGlobal"
                    class="material-symbols-rounded ms-2 global-filter-icon"
                    [matTooltip]="'FILTER_DIALOG.GLOBAL_FILTER' | translate">public
          </mat-icon>
        </button>
      }
    </ng-container>
  }
</mat-menu>
<mat-menu #mapMenu="matMenu" class="toolbar-menu">
  @if (!isDefaulter) {
    <button mat-menu-item (click)="createNewMap()">
      <i class="icon-smap-action-create"></i>
      <span>{{ 'MENU.CREATE_SMAP' | translate }}</span>
    </button>
  }
  <button mat-menu-item (click)="selectMap()">
    <i class="icon-smap-action-manage"></i>
    <span>{{ 'MENU.MANAGE_SMAPS' | translate }}</span>
  </button>
  @if (!isDefaulter) {
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="importSmapArchive()">
      <mat-icon class="material-symbols-rounded">publish</mat-icon>
      <span>{{ 'NAV_MISC.IMPORT_SMAP' | translate }}</span>
    </button>
  }
  @if (maps.length) {
    <mat-divider></mat-divider>
  }
  @if (unseenMaps.length) {
    <button mat-menu-item
            data-testid="unseen-smaps-menu"
            [matMenuTriggerFor]="unseenMapMenu"
            [matTooltip]="'MENU.UNSEEN_SMAPS_TIP' | translate"
            matTooltipPosition="right">
      <span class="d-flex align-items-center map-menu-icons">
        <span class="icon-smap-metadata-unseen"></span>
        {{ 'MENU.UNSEEN_SMAPS' | translate }} ({{ unseenMaps.length }})
      </span>
    </button>
  }
  @for (map of maps; track map.id || $index) {
    <button mat-menu-item (click)="selectMap(map)">
      @if (map) {
        <span class="d-flex align-items-center map-menu-icons"
              [matTooltip]="map.description || ''"
              matTooltipPosition="right">
                  <span [ngClass]="[getMapAccessIcon(map)]"></span>
          {{ map.name }}
                </span>
      }
    </button>
  }
</mat-menu>

<mat-menu #unseenMapMenu="matMenu" class="toolbar-menu">
  @for (map of unseenMaps; track map.id) {
    <button mat-menu-item (click)="selectMap(map)">
      <span class="d-flex align-items-center map-menu-icons"
            [matTooltip]="map.description || ''"
            matTooltipPosition="right">
        <span [ngClass]="[getMapAccessIcon(map)]"></span>
        {{ map.name }}
      </span>
    </button>
  }
</mat-menu>
<mat-menu #viewsMenu="matMenu" class="toolbar-menu">
  @if (currentMap) {
    @if (!readModeAppState && !isDefaulter) {
      @if (!isInIframe()) {
        <button mat-menu-item
                (click)="createView()"
                [disabled]="!canEdit()">
          <i class="icon-smap-action-create"></i>
          <span>{{ 'MENU.CREATE_SCENE' | translate }}</span>
        </button>
        <button mat-menu-item
                [disabled]="!canEdit()"
                (click)="selectView()">
          <span class="icon-smap-action-manage"></span>
          <span>{{ 'MENU.MANAGE_SCENES' | translate }}</span>
        </button>
      }
    }
    @if ((views.length > 0 && !readModeAppState && canManageViews) && !isInIframe() && !isDefaulter) {
      <mat-divider></mat-divider>
    }

    <ng-container *ngIf="(!canManageViews && views.length === 0) && !isInIframe()">
      <button disabled mat-menu-item>{{ 'MENU.NO_SAVED_SCENES' | translate }}</button>
    </ng-container>
    <ng-container *ngIf="views.length > 0">
      @for (view of views; track view.id) {
        @if (shouldShowView(view)) {
          <button mat-menu-item
                  (click)="startView(view)"
                  matTooltipPosition="right"
                  [matTooltip]="view.description ? view.description : view.name">
            {{ view.name }}
          </button>
        }
      }
    </ng-container>
  }
</mat-menu>
<mat-menu #tourMenu="matMenu" class="toolbar-menu">
  @if (currentMap) {
    @if (!readModeAppState && !isDefaulter) {
      <button mat-menu-item
              (click)="createTour()"
              [disabled]="!canEdit()">
        <i class="icon-smap-action-create"></i>
        <span>{{ 'MENU.CREATE_STORY' | translate }}</span>
      </button>
      <button mat-menu-item
              (click)="selectTour()"
              [disabled]="!canEdit()">
        <span class="icon-smap-action-manage"></span>
        <span>{{ 'MENU.MANAGE_STORIES' | translate }}</span>
      </button>
      @if (tours.length > 0 && !readModeAppState) {
        <mat-divider></mat-divider>
      }
    }
    <ng-container *ngIf="!canManageTours && tours.length === 0 && !isInIframe()">
      <button disabled mat-menu-item>{{ 'MENU.NO_SAVED_STORIES' | translate }}</button>
    </ng-container>
    @for (tour of tours; track tour.id) {
      <button mat-menu-item
              (click)="startTour(tour)"
              matTooltipPosition="right"
              [matTooltip]="tour.description ? tour.description : tour.name">
        {{ tour.name }}
      </button>
    }
  }
</mat-menu>
<mat-menu #helpMenu="matMenu" class="toolbar-menu">
  <!-- Run Onboarding Guide (re-triggerable FTUE tour) -->
  <button (click)="runOnboardingGuide()" mat-menu-item [disabled]="!currentMap">
    <mat-icon class="material-symbols-outlined">tour</mat-icon>
    <span>{{ 'NAV_MISC.ONBOARDING_GUIDE' | translate }}</span>
  </button>

  @if (!isIframe) {
    <mat-divider></mat-divider>

    <button (click)="openVideoTutorialsDialog()" mat-menu-item>
      <mat-icon class="material-symbols-rounded">school</mat-icon>
      <span>{{ 'NAV_MISC.VIDEO_TUTORIALS' | translate }}</span>
    </button>

    <button (click)="openMarkdownRulesDialog()" mat-menu-item>
      <mat-icon class="material-symbols-rounded">markdown</mat-icon>
      <span>{{ 'NAV_MISC.MARKDOWN_RULES' | translate }}</span>
    </button>

    <mat-divider></mat-divider>

    <button (click)="openReleaseNotes()" mat-menu-item>
      <mat-icon class="material-symbols-rounded">news</mat-icon>
      <span>{{ 'NAV_MISC.RELEASE_NOTES' | translate }}</span>
    </button>

    <mat-divider></mat-divider>

    <button (click)="sendMail()" mat-menu-item>
      <mat-icon class="material-symbols-rounded">support</mat-icon>
      <span>{{ 'NAV_MISC.CUSTOMER_SUPPORT' | translate }}</span>
    </button>

    <button (click)="visitWebsite()" mat-menu-item>
      <mat-icon class="material-symbols-rounded">language</mat-icon>
      <span>{{ 'NAV_MISC.COMPANY_WEBSITE' | translate }}</span>
    </button>
  }
</mat-menu>

<!-- Models Menu -->
<mat-menu #modelsMenu="matMenu" class="toolbar-menu">
  @if (currentMap) {
    @if (!isDefaulter) {
      <button mat-menu-item
              (click)="createModel()"
              [disabled]="!canEdit()">
        <i class="icon-smap-action-create"></i>
        <span>{{ 'NAV_MISC.CREATE_MODEL' | translate }}</span>
      </button>

      <button mat-menu-item
              (click)="manageModels()">
        <i class="icon-smap-action-manage"></i>
        <span>{{ 'NAV_MISC.MANAGE_MODELS' | translate }}</span>
      </button>
    }

    <mat-divider *ngIf="nodeModels.length > 0 || linkModels.length > 0"></mat-divider>

    <!-- Node Models Section -->
    <ng-container *ngIf="nodeModels.length > 0">
      @for (model of nodeModels; track model.id) {
        <button mat-menu-item
                (click)="applyModel(model)"
                [matTooltip]="model.description || ''"
                [matTooltipDisabled]="!model.description"
                matTooltipPosition="right"
                [disabled]="!canEdit() || isDefaulter">
          @if (modelIcon(model.id)) {
            <span class="legend-shape-icon"
                  [innerHTML]="modelIcon(model.id)"></span>
          } @else {
            <mat-icon class="material-symbols-rounded">circle</mat-icon>
          }
          <span>{{ model.name }}</span>
        </button>
      }
    </ng-container>

    <!-- Divider between node and link models if both exist -->
    <mat-divider *ngIf="nodeModels.length > 0 && linkModels.length > 0"></mat-divider>

    <!-- Link Models Section -->
    <ng-container *ngIf="linkModels.length > 0">
      @for (model of linkModels; track model.id) {
        <button mat-menu-item
                (click)="applyModel(model)"
                [matTooltip]="model.description || ''"
                [matTooltipDisabled]="!model.description"
                matTooltipPosition="right"
                [disabled]="!canEdit() || isDefaulter">
          @if (modelIcon(model.id)) {
            <span class="legend-shape-icon"
                  [innerHTML]="modelIcon(model.id)"></span>
          } @else {
            <mat-icon class="material-symbols-rounded">diagonal_line</mat-icon>
          }
          <span>{{ model.name }}</span>
        </button>
      }
    </ng-container>
  }

</mat-menu>
